import 'waypoints/lib/jquery.waypoints.min.js';

export default {
    init() {
        let s = $('.flexible-row--section');
        const nav = $('.waypoint-nav li a');
        var list = $('.waypoint-nav').append('<ul></ul>').find('ul');

        if( s.length ){
            s.each(function() {
                // console.log( $(this).attr('id') );
                list.append('<li class="waypoint-nav__item waypoint-nav__item--'+ $(this).attr('id') +'"><a href=#'+ $(this).attr('id') +'><span>'+ $(this).attr('data-name') +'</span></a></li>');
            });

            s.waypoint({
                handler: function(direction){
                    $('.waypoint-nav').addClass('waypoint-nav--active');

                    if(direction == 'up') {
                        $('.waypoint-nav__item').removeClass('waypoint-nav__item--active');
                    } else {
                        var activeItem = $('.waypoint-nav__item--' + this.element.id );

                        console.log(this.element.id)

                        $('.waypoint-nav__item').removeClass('waypoint-nav__item--active');
                        activeItem.addClass('waypoint-nav__item--active');
                    }
                },
                offset: '15%'
            });
        }
    },
};



// WEBPACK FOOTER //
// ./scripts/routes/waypoint-sections.js